<template>
  <div class="news" :class="{en: $i18n.locale === 'en'}">
    <div class="date" >{{ toDate(UtcDate) }}</div>
    <div class="title"><router-link class="inner" :to="link">{{ title }}</router-link></div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    index: Number,
    UtcDate: String,
    title: String,
    content: String,
    link: String,
  },
  methods: {
    toDate(date) {
      if (this.$i18n.locale === 'ja') {
        return dayjs(date).format("YYYY年M月D日");
      } else {
        return dayjs(date).format("MMMM D, YYYY");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  padding-bottom: 20px;
  .date {
    font-size: 11px;
    margin-bottom: 5px;
  }
  .title {
    font-size: 11px;
    margin-bottom: 26px;
    line-height: 1.5;
  }
  .title-top {
    font-size: 11px;
    margin-bottom: 24px;
  }
  .content-top {
    font-size: 11px;
    margin-bottom: 33px;
    line-height: 1.9;
  }
}

@media (max-width: ($mobile-vw - 1px)) {
  .news .content-top ::v-deep br{
    display: none;
  }
}

@media (min-width: $mobile-vw) {
  .news {
    padding: 7px 0 21px 0;
    .date {
      font-size: 16px;
      margin-bottom: 15px;
    }
    .title {
      font-size: 18px;
      letter-spacing: 0.04em;
      margin-bottom: 5px;
    }
    &.en .title {
      letter-spacing: 0em;
    }
    .title-top {
      font-size: 16px;
    }
    .content-top {
      font-size: 18px;
      letter-spacing: 0.02em;
      margin-bottom: 60px;
      line-height: 1.6;
    }
    &.en .content-top {
      letter-spacing: 0em;
    }
  }
}
</style>